import { render, staticRenderFns } from "./KasProduksiFiberList.vue?vue&type=template&id=f52770ae"
import script from "./KasProduksiFiberList.vue?vue&type=script&lang=js"
export * from "./KasProduksiFiberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports